import { ActivityEventType } from '@warebee/shared/import-converter';
import { useTranslation } from 'react-i18next';

export type ActivityEventTypeDetails = {
  id: ActivityEventType;
  title: string;
  description: string;
};

function useActivityEventTypeDetails(): ActivityEventTypeDetails[] {
  const { t } = useTranslation('feed');
  return [
    {
      id: ActivityEventType.PICK,
      title: t`Pick`,
      description: t`Retrieving items from their storage location`,
    },
    {
      id: ActivityEventType.PUT,
      title: t`Put`,
      description: t`Placing items into a storage location`,
    },
    {
      id: ActivityEventType.PACK,
      title: t`Pack`,
      description: t`Packaging items for shipment or storage`,
    },
    {
      id: ActivityEventType.MOVE,
      title: t`Move`,
      description: t`Relocating items between locations`,
    },
    {
      id: ActivityEventType.STACK,
      title: t`Stack`,
      description: t`Arranging items in a vertical stack`,
    },
    {
      id: ActivityEventType.HOLD,
      title: t`Hold`,
      description: t`Temporarily suspending item movement or processing`,
    },
    {
      id: ActivityEventType.WAIT,
      title: t`Wait`,
      description: t`Paused state waiting for next action`,
    },
    {
      id: ActivityEventType.COUNT,
      title: t`Count`,
      description: t`Inventory counting or verification`,
    },
    {
      id: ActivityEventType.JOB_START,
      title: t`Job Start`,
      description: t`Beginning of a work task or process`,
    },
    {
      id: ActivityEventType.JOB_END,
      title: t`Job End`,
      description: t`Completion of a work task or process`,
    },
    {
      id: ActivityEventType.OTHER,
      title: t`Other`,
      description: t`Miscellaneous activities not covered by other types`,
    },
    {
      id: ActivityEventType.IGNORE,
      title: t`Ignore`,
      description: t`Events to be excluded from processing or reporting`,
    },
  ];
}

export default useActivityEventTypeDetails;
